import React from "react";
import RadioInput from "./RadioInput";

export default class FormInputs extends React.Component {

    constructor(props) {
        super(props);
    }

    generateTextGroup(input, formId) {

        return <div className='form__input-wrapper'>
                    <label for={`${input.type}-${formId}`}>{input.label}</label>
                    <input type={input.type} name={input.type} placeholder={input.placeholder} id={`${input.type}-${formId}`}/>
                </div>
    }

    static mapFormInput(input, formId) {
        switch (input.type) {
            case 'password':
            case 'text':
                return;
            case 'radio':
                return <RadioInput key={input} options={input.options} label={input.label} formId={formId}/>;
            default:
                return '';
        }
    }
}